"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (one, two) => {
    if (one === two)
        return true;
    const oneType = typeof one;
    const twoType = typeof two;
    if (oneType !== twoType)
        return false;
    const oneIsArray = Array.isArray(one);
    const twoIsArray = Array.isArray(two);
    if (oneIsArray && twoIsArray) {
        if (one.length !== two.length)
            return false;
        return one.every((item, i) => item === two[i]);
    }
    if (!oneIsArray &&
        !twoIsArray &&
        oneType === 'object' &&
        twoType === 'object') {
        const oneEntries = Object.entries(one);
        const twoEntries = Object.entries(two);
        if (oneEntries.length !== twoEntries.length)
            return false;
        return oneEntries.every(([key, value]) => value === two[key]);
    }
    return false;
};
//# sourceMappingURL=shallow-equal.js.map